import { render } from "./NewPassword.vue?vue&type=template&id=04904ac8&scoped=true"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"

import "./NewPassword.vue?vue&type=style&index=0&id=04904ac8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04904ac8"],['__file',"webpack-assets/vue/templates/site/authorization/modal/NewPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04904ac8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04904ac8', __exports__)) {
    api.reload('04904ac8', __exports__)
  }
  
  module.hot.accept("./NewPassword.vue?vue&type=template&id=04904ac8&scoped=true", () => {
    api.rerender('04904ac8', render)
  })

}


export default __exports__